"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateColumnsOffsets = void 0;
function calculateColumnsOffsets({ columns }) {
    const columnsOffsets = [];
    let startIndexLimit = 0;
    let endIndexLimit = null;
    let isPrevService = true;
    let edgeColumnOffset = 0;
    for (let i = 0; i < columns.length; i++) {
        const column = columns[i];
        const width = column.width || 0;
        const half = width / 2;
        if (column.isService) {
            if (isPrevService) {
                startIndexLimit = i + 1;
            }
            if (!isPrevService && endIndexLimit === null) {
                endIndexLimit = i - 1;
            }
            isPrevService = true;
        }
        else {
            isPrevService = false;
        }
        columnsOffsets.push({
            leftOffset: edgeColumnOffset,
            rightOffset: edgeColumnOffset + width,
            equator: edgeColumnOffset + half
        });
        edgeColumnOffset += width;
    }
    return {
        columnsOffsets,
        edgeColumnOffset,
        startIndexLimit,
        endIndexLimit: Math.max(endIndexLimit || columns.length - 1, 0)
    };
}
exports.calculateColumnsOffsets = calculateColumnsOffsets;
//# sourceMappingURL=calculateColumnsOffsets.js.map